import { UserRole } from '@shared/utils/base-auth';
import { ShareTypeModel } from '@shared/utils/list-officer';

export class LoggedInOfficer {
  constructor(
    public uid: string,
    public firstName: string,
    public lastName: string,
    public isDeleted: boolean,
    public agencyUid: string,
    public picturePath: string,
    public autoClearFilters: boolean,
    public role: UserRole,
    public emailAddress: string,
    public useMilitaryTime: boolean,
    public canDownloadFiles: boolean,
    public timezone: string,
    public shareType: ShareTypeModel,
    public userUIConfiguration: UserUIConfiguration
  ) {}
}

export class LoggedInOfficerResponse {
  constructor(
    public FirstName: string,
    public LastName: string,
    public Customer: CustomerResponse,
    public AutoClearFilters: boolean,
    public PictureFullPath: string,
    public UID: string,
    public Role: UserRole,
    public EmailAddress: string,
    public CanDownloadFiles: boolean,
    public TimeZone: string,
    public ShareType: ShareTypeModel,
    public UserUIConfiguration: UserUIConfigurationResponse
  ) {}
}

export class CustomerResponse {
  constructor(public UID: string, public UseMilitaryTime: boolean) {}
}

export class ChangePassword {
  constructor(public password: string) {}
}

export class UserUIConfiguration {
  constructor(public isNotificationBannerRead: boolean) {}
}

export class UserUIConfigurationResponse {
  constructor(public IsNotificationBannerRead: boolean) {}
}
